import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { authorSelected } from "../../features/filter/filterSlice";
const VideoGridItem = ({ video }) => {
  const { id, title, thumbnail, author, views, date, avatar } = video;
  const dispatch = useDispatch();
  const handleAuthorFilter = (author) => {
    dispatch(authorSelected(author));
  };
  return (
    <div className='col-span-12 sm:col-span-6 md:col-span-3 duration-300 hover:scale-[1.03]'>
      <div className='w-full flex flex-col'>
        <div className='relative'>
          <Link to={`/video/${id}`}>
            <img src={thumbnail} className='w-full h-auto' alt='Some video title' />
          </Link>

          <p className='absolute right-2 bottom-2 bg-gray-900 text-gray-100 text-xs px-1 py'>{video.duration}</p>
        </div>
        <Link to={`/video/${id}`}>
          <p className='text-slate-900 text-sm font-semibold mt-4'>{title}</p>
        </Link>
        <div className='flex flex-row mt-2 gap-2'>
          <button onClick={() => handleAuthorFilter(author)} className='shrink-0'>
            <img src={avatar} className='rounded-full h-6 w-6' alt={author} />
          </button>

          <div clas='flex flex-col'>
            <p
              onClick={() => handleAuthorFilter(author)}
              className='text-gray-400 cursor-pointer text-xs mt-2 hover:text-gray-600'
            >
              {author}
            </p>
            <p className='text-gray-400 text-xs mt-1'>
              {views} . {date}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoGridItem;
